import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Catalog from "../pages/catalog/page";
import Packages from "../pages/packages/page";
import ProductDetail from "../pages/product-detail/page";
import PackageDetail from "../pages/package-detail/page";
import Checkout from "../pages/checkout/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/catalogo",
    element: <Catalog />,
  },
  {
    path: "/paquetes",
    element: <Packages />,
  },
  {
    path: "/producto/:id",
    element: <ProductDetail />,
  },
  {
    path: "/paquetes/:id",
    element: <PackageDetail />,
  },
  {
    path: "/checkout",
    element: <Checkout />,
  },
  {
    path: "/contacto",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
